import { call, Effect, takeLatest } from 'redux-saga/effects';

import { types, actions } from 'ducks/supplierEnquiry/settings/financial';

import { callApi } from '../../utils';
import * as api from 'api/supplierEnquiry/settings/financial';
import { IDataAction } from 'ducks/utils';

function* getSupplierBalancesDetailsDetails(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = actions.saga.getSupplierFinancialSettings;
  yield callApi(
    call(api.fetch, action.data),
    success,
    failure
  );
}

export default function* rootCustomerSaga(): IterableIterator<Effect> {
  yield takeLatest(types.getSupplierFinancialSettings, getSupplierBalancesDetailsDetails);
}
